import {ref} from 'vue';

export function useWindowNavGlobals() {
    const navTypeFunnel = ref(false);
    const navTypeSearch = ref(false);
    const searchFormVisible = ref(false);

    if (window.__NAVBAR_UNLOGGED__) {
        const unloggedNavGlobals = window.__NAVBAR_UNLOGGED__;

        navTypeFunnel.value = unloggedNavGlobals.navTypeFunnel;
        navTypeSearch.value = unloggedNavGlobals.navTypeSearch;
        searchFormVisible.value = unloggedNavGlobals.searchFormVisible;
    }

    return {
        navTypeFunnel,
        navTypeSearch,
        searchFormVisible,
    };
}
